import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

const RELATION_COLOR = '00ba16';
const FUNCTION_COLOR = 'f96f2f';
const ENTITY_TYPE_COLOR = '0026ff';
const LITERAL_COLOR = 'd52deb';

export const rqlBrowserTheme = {
    base: 'vs', // can also be vs-dark or hc-black
    inherit: true, // can also be false to completely replace the builtin rules
    rules: [
        {token: 'variable', foreground: '000000'},
        {token: 'rql.keyword', foreground: '000000', fontStyle: 'bold'},
        {token: 'identifier.entity-type', foreground: ENTITY_TYPE_COLOR},
        {token: 'identifier.relation', foreground: RELATION_COLOR},
        {token: 'rql.function', foreground: FUNCTION_COLOR},
        {token: 'string', foreground: LITERAL_COLOR},
        {token: 'number', foreground: LITERAL_COLOR},
    ],
    colors: {'editor.background': '#ffffff'},
} as monaco.editor.IStandaloneThemeData;
